import {
  InfoBlockField,
  NewBeneficiaryValues,
  NewBranchValues,
  NewTerminalValues,
} from '../types/add_commerce.types';
import { BankAccountTypesEnum } from '../types/enums/bank-account-types.enum';
import { CurrencyEnum } from '../types/enums/currency.enum';
import { DocumentTypeEnum } from '../types/enums/document-type.enum';
import { LawsEnum } from '../types/enums/law.enum';
import { PhoneCountryCodesEnum } from '../types/enums/phone-country-codes.enum';
import { TafaceBusinessTypeEnum } from '../types/enums/taface-business-type.enum';
import { TafaceCertificaDurationEnum } from '../types/enums/taface-certificate-duration.enum';
import { TafaceCompanyTypeEnum } from '../types/enums/taface-company-type.enum';
import { TerminalTypesEnum } from '../types/enums/terminal-types.enum';

const formatter = new Intl.NumberFormat('es-UY', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export interface Bank {
  id: string;
  name: string;
  lengths: number | number[] | null;
}

export interface LawFormField {
  label: string;
  fieldname: string;
  value: LawsEnum;
}

export interface AccountType {
  name: string;
  value: BankAccountTypesEnum;
}

export interface BusinessType {
  name: string;
  value: number;
}

export const BROU_BANK_ID = '50';
export const NACION_AR_BANK_ID = '57';
export const SANTANDER_BANK_ID = '55';
export const BANDES_BANK_ID = '56';
export const PROVINCIA_BANK_ID = '59';
export const HERITAGE_BANK_ID = '60';
export const PREX_BANK_ID = '61';
export const BHU_BANK_ID = '62';
export const OCA_BLUE_BANK_ID = '63';
export const MERCADO_PAGO_BANK_ID = '64';
export const NOBILIS_BANK_ID = '65';
export const FUCEREP_BANK_ID = '66';
export const BTG_PACTUAL_BANK_ID = '67';
export const MIDINERO_BANK_ID = '68';

// NOTE: BANCO PROVINCIA is not included yet by order of the client
// NOTE: Do not uncomment any of the banks below without explicit client authorization
export const banks: Bank[] = [
  { id: BROU_BANK_ID, name: 'BROU', lengths: 14 },
  { id: '51', name: 'CITIBANK', lengths: 10 },
  { id: '52', name: 'SCOTIABANK', lengths: 10 },
  { id: '53', name: 'ITAÚ', lengths: 7 },
  { id: '54', name: 'BBVA', lengths: 8 },
  { id: SANTANDER_BANK_ID, name: 'SANTANDER', lengths: 12 },
  { id: BANDES_BANK_ID, name: 'BANDES', lengths: 9 },
  //{ id: '58', name: 'HSBC', lengths: 10 },
  //{ id: NACION_AR_BANK_ID, name: 'BANCO NACIÓN AR', lengths: 12 },
  // { id: PROVINCIA_BANK_ID, name: 'BANCO PROVINCIA AR', lengths: null },
  { id: HERITAGE_BANK_ID, name: 'HERITAGE', lengths: 9 },
  //{ id: PREX_BANK_ID, name: 'PREX', lengths: null },
  { id: BHU_BANK_ID, name: 'BHU', lengths: 12 },
  //{ id: OCA_BLUE_BANK_ID, name: 'OCA BLUE', lengths: null },
  //{ id: MERCADO_PAGO_BANK_ID, name: 'MERCADO PAGO', lengths: null },
  //{ id: NOBILIS_BANK_ID, name: 'NOBILIS', lengths: null },
  //{ id: FUCEREP_BANK_ID, name: 'FUCEREP', lengths: null },
  //{ id: BTG_PACTUAL_BANK_ID, name: 'BTG PACTUAL', lengths: null },
  //{ id: MIDINERO_BANK_ID, name: 'MIDINERO', lengths: null },
];

const SELECCIONAR_DEFAULT_OPTION = '';

export const banksWithBranchAccount: string[] = [
  SELECCIONAR_DEFAULT_OPTION,
  SANTANDER_BANK_ID,
  BANDES_BANK_ID,
  PROVINCIA_BANK_ID,
  PREX_BANK_ID,
  BHU_BANK_ID,
];

export const banksWithSubaccount: string[] = [
  SELECCIONAR_DEFAULT_OPTION,
  BROU_BANK_ID,
  PROVINCIA_BANK_ID,
  HERITAGE_BANK_ID,
  PREX_BANK_ID,
  BHU_BANK_ID,
];

export const bankAccountTypes: AccountType[] = [
  { name: 'Cuenta Corriente', value: BankAccountTypesEnum.CUENTA_CORRIENTE },
  { name: 'Caja de Ahorro', value: BankAccountTypesEnum.CAJA_DE_AHORRO },
];

export const terminalNetworkOptions: InfoBlockField[] = [
  { name: 'New Age Data (NAD)', value: TerminalTypesEnum.NAD },
  { name: 'POS2000', value: TerminalTypesEnum.POS2000 },
  { name: 'Scanntech', value: TerminalTypesEnum.SCANNTECH },
  { name: 'Resonance', value: TerminalTypesEnum.RESONANCE },
  { name: 'Handy', value: TerminalTypesEnum.HANDY },
  { name: 'Sisteco', value: TerminalTypesEnum.SISTECO },
  { name: 'Geocom', value: TerminalTypesEnum.GEOCOM },
  { name: 'Pranasys', value: TerminalTypesEnum.PRANASYS },
  { name: 'Red Fiserv', value: TerminalTypesEnum.FISERV },
  { name: 'Red Oca', value: TerminalTypesEnum.OCA },
  { name: 'Red Visanet', value: TerminalTypesEnum.VISANET },
];

export const laws: InfoBlockField[] = [
  { name: 'Ley 19.210', value: LawsEnum.law_19210.toString() },
  { name: 'Ley 17.934 (Restaurantes)', value: LawsEnum.law_17934.toString() },
  { name: 'Ley 18.083 (IMESI)', value: LawsEnum.law_18083.toString() },
  { name: 'Ley 18.910 (AFAM)', value: LawsEnum.law_18910.toString() },
];

export const lawsFormFields: LawFormField[] = [
  { label: laws[0].name, fieldname: 'law_19210', value: LawsEnum.law_19210 },
  { label: laws[1].name, fieldname: 'law_17934', value: LawsEnum.law_17934 },
  { label: laws[2].name, fieldname: 'law_18083', value: LawsEnum.law_18083 },
  { label: laws[3].name, fieldname: 'law_18910', value: LawsEnum.law_18910 },
];

export const basicInfoFields: string[] = [
  'Nº de RUT',
  'Nombre fantasía',
  'Razón social',
  'Nombre y apellidos de contacto',
  'Teléfono',
  'Celular',
  'Email',
  'Rubro',
  'Tipo de empresa',
  'Tipo de contribuyente',
];

export const incompleteBasicInfoFields: string[] = [
  'Nº de RUT',
  'Nombre fantasía',
  'Razón social',
  'Nombre y apellidos de contacto',
  'Teléfono',
  'Celular',
  'Email',
];

export const branchFields = [
  'Nombre Fantasía',
  'Departamento',
  'Localidad',
  'Dirección',
  'Apto',
  'Solar',
  'Manzana',
];

export const beneficiaryFields = [
  'Tipo de documento',
  'Nº de Documento',
  'Nombre y apellido',
  '% de participación',
  'Es PEP',
  'Es Familiar',
];

export const mainAddressFields: string[] = [
  'Departamento',
  'Localidad',
  'Dirección',
  'Apto',
  'Solar',
  'Manzana',
];

export const bankAccountFields: string[] = [
  'Banco',
  'Nº de cuenta',
  'Moneda',
  'Nº de sucursal',
  'Titular de la cuenta',
];

export const salesOperationFields: InfoBlockField[] = [{ name: 'Venta con tarjeta presente', value: '-' }];

export const economicActivityFields: string = 'Rubro';
export const businessPlansFields: string = 'Moneda';
export const tributaryInfoFields: string = 'Tipo de contribuyente';

export const documentTypes: InfoBlockField[] = [
  { name: 'Cédula de Identidad', value: DocumentTypeEnum.CI },
  { name: 'Pasaporte', value: DocumentTypeEnum.PASSPORT },
];

export const currencies: InfoBlockField[] = [
  { name: 'PESOS URUGUAYOS', value: CurrencyEnum.URUGUAYAN_PESOS },
  { name: 'DÓLAR ESTADOUNIDENSE', value: CurrencyEnum.US_DOLLAR },
  { name: 'AMBAS', value: 'ambas' },
];

export const newBeneficiary: NewBeneficiaryValues = {
  documentType: null,
  documentNumber: '',
  firstName: '',
  lastName: '',
  participationPercentage: null,
  branchOfficeId: null,
  isPep: false,
  isRelative: false,
  backDocument: null,
  frontDocument: null,
  beneficiary_branch_office: null,
};

export const newBranch: NewBranchValues = {
  fantasyName: '',
  businessCategoryId: undefined,
  state: undefined,
  city: undefined,
  addressStreet: '',
  addressNumber: undefined,
  addressFlatNumber: undefined,
  addressSolar: undefined,
  addressPlot: undefined,
};

export const conditionsAndTariffStandarData = [
  {
    title: 'TARJETA DE CRÉDITO',
    headings: ['Condiciones', 'Venta con tarjeta local'],
    rows: [
      { plan: '3 pagos', currency: 'Dólares/Pesos uruguayos', fees: '4.80%', deferred: '52 días' },
      { plan: '4 pagos', currency: 'Dólares/Pesos uruguayos', fees: '4.80%', deferred: '67 días' },
      { plan: '5 pagos', currency: 'Dólares/Pesos uruguayos', fees: '4.80%', deferred: '82 días' },
      { plan: '6 pagos', currency: 'Dólares/Pesos uruguayos', fees: '4.80%', deferred: '90 días' },
      {
        plan: 'Combustible / 1 pago',
        currency: 'Dólares/Pesos uruguayos',
        fees: '3,75%',
        deferred: '2 días',
      },
    ],
  },
  {
    title: 'TARJETA DE CRÉDITO',
    headings: ['Condiciones', 'Venta con tarjeta internacional'],
    rows: [
      { plan: '1 pago', currency: 'Dólares/Pesos uruguayos', fees: '4,40%', deferred: '2 días' },
      {
        plan: 'Combustible / 1 pago',
        currency: 'Dólares/Pesos uruguayos',
        fees: '4,40%',
        deferred: '2 días',
      },
    ],
  },
  {
    title: 'TARJETA DÉBITO-DOMÉSTICO',
    headings: ['Condiciones', 'Venta con tarjeta local'],
    rows: [
      { plan: '1 pago', currency: 'Dólares/Pesos uruguayos', fees: '1,13%', deferred: '1 día' },
      {
        plan: 'Combustible / 1 pago',
        currency: 'Dólares/Pesos uruguayos',
        fees: '0,99%',
        deferred: '67 días',
      },
    ],
  },
  {
    title: 'TARJETA PREPAGA-DOMÉSTICO',
    headings: ['Condiciones', 'Venta con tarjeta local'],
    rows: [
      { plan: '1 pago', currency: 'Dólares/Pesos uruguayos', fees: '1,18%', deferred: '1 día' },
      { plan: 'Combustible / 1 pago', currency: 'Dólares/Pesos uruguayos', fees: '1,18%', deferred: '1 día' },
    ],
  },
  {
    title: 'TARJETA DE DÉBITO MC/MAESTRO/PREPAGA',
    headings: ['Condiciones', 'Venta con tarjeta local'],
    rows: [
      { plan: '1 pago', currency: 'Dólares/Pesos uruguayos', fees: '1,18%', deferred: '1 día' },
      { plan: 'Combustible / 1 pago', currency: 'Dólares/Pesos uruguayos', fees: '1,18%', deferred: '1 día' },
    ],
  },
];

export const personalizedTariffMasterDataDefault = [
  {
    rows: [
      {
        plan: 'DÉBITO',
        currency: formatter.format(1.12),
        suffix: '%',
        fees: formatter.format(1.12),
        deferred: formatter.format(1.06),
      },
      {
        plan: 'PREPAGO',
        currency: formatter.format(1.17),
        suffix: '%',
        fees: formatter.format(1.17),
        deferred: formatter.format(1.11),
      },
      {
        plan: 'CRÉDITO CONTADO',
        currency: formatter.format(3.35),
        suffix: '%',
        fees: formatter.format(3.35),
        deferred: formatter.format(3.18),
      },
      {
        plan: 'CRÉDITO CUOTAS',
        currency: formatter.format(3.92),
        suffix: '%',
        fees: formatter.format(3.92),
        deferred: formatter.format(3.72),
      },
      {
        plan: 'Extranjeros DÉBITO',
        currency: formatter.format(3.4),
        suffix: '%',
        fees: formatter.format(3.4),
        deferred: formatter.format(3.4),
      },
      {
        plan: 'Extranjeros CRÉDITO',
        currency: formatter.format(3.4),
        suffix: '%',
        fees: formatter.format(3.4),
        deferred: formatter.format(3.4),
      },
    ],
  },
];

export const personalizedTariffVisaDataDefault = [
  {
    rows: [
      {
        plan: 'DÉBITO',
        currency: formatter.format(1.05),
        suffix: '%',
        fees: formatter.format(1.12),
        deferred: formatter.format(0.99),
      },
      {
        plan: 'PREPAGO',
        currency: formatter.format(1.1),
        suffix: '%',
        fees: formatter.format(1.1),
        deferred: formatter.format(1.04),
      },
      {
        plan: 'CRÉDITO CONTADO',
        currency: formatter.format(3.15),
        suffix: '%',
        fees: formatter.format(3.15),
        deferred: formatter.format(2.96),
      },
      {
        plan: 'CRÉDITO CUOTAS',
        currency: formatter.format(4.44),
        suffix: '%',
        fees: formatter.format(4.44),
        deferred: formatter.format(4.17),
      },
      {
        plan: 'Extranjeros DÉBITO',
        currency: formatter.format(3.4),
        suffix: '%',
        fees: formatter.format(3.4),
        deferred: formatter.format(3.4),
      },
      {
        plan: 'Extranjeros CRÉDITO',
        currency: formatter.format(3.4),
        suffix: '%',
        fees: formatter.format(3.4),
        deferred: formatter.format(3.4),
      },
    ],
  },
];

export const standarComisionHeadings: string[] = ['Plan de pago', 'Moneda', 'Comisión', 'Diferido pago'];

export const masterPersonalizedComisionHeadings: string[] = [
  '',
  'Arancel personalizado',
  'Arancel sugerido',
  'Arancel mínimo',
];

export const visaPersonalizedComisionHeadings: string[] = [
  '',
  'Arancel personalizado',
  'Arancel sugerido',
  'Arancel mínimo',
];

// First heading differs per brand so each table's editable inputs get unique ids.
export const masterManualComisionHeadings: string[] = [
  'Master',
  'Arancel manual',
  'Arancel sugerido',
  'Arancel mínimo',
];

export const visaManualComisionHeadings: string[] = [
  'Visa',
  'Arancel manual',
  'Arancel sugerido',
  'Arancel mínimo',
];

export const terminalHeadings: string[] = [
  'Producto',
  'Facturación electrónica',
  'Cantidad',
  'Valor UI',
  'Precio en pesos',
];

export const newTerminal: NewTerminalValues = { type: '', number: null };

export const COMMENT_MAX_LENGTH: number = 250;

export const integrationType: { value: number; name: string }[] = [
  { value: 1, name: 'Web CheckOut' },
  { value: 4, name: 'QR' },
  { value: 5, name: 'Link de pago' },
];

export const INTEGRATION_NO = '0';
export const INTEGRATION_OTHERS = '106';
export type IntegrationOptions = typeof INTEGRATION_NO | typeof INTEGRATION_OTHERS;

export const integrations: { value: string; label: string }[] = [
  { value: INTEGRATION_NO, label: 'No' },
  { value: '64', label: 'ABECH' },
  { value: '41', label: 'Avance Informática' },
  { value: '73', label: 'BAS' },
  { value: '42', label: 'Bit' },
  { value: '19', label: 'Boticario' },
  { value: '66', label: 'CDSOFT' },
  { value: '9', label: 'ContaWIN' },
  { value: '49', label: 'Cualit' },
  { value: '6', label: 'Designware' },
  { value: '45', label: 'ePharma' },
  { value: '58', label: 'EURESIS' },
  { value: '30', label: 'Eximia' },
  { value: '101', label: 'FacturaLista' },
  { value: '68', label: 'FACTURAYA' },
  { value: '83', label: 'GESTCOM (GARGANO)' },
  { value: '84', label: 'GNS' },
  { value: '48', label: 'GSOFT' },
  { value: '4', label: 'ICG' },
  { value: '39', label: 'InfoFarma' },
  { value: '20', label: 'Infra Sistemas' },
  { value: '43', label: 'Insis' },
  { value: '56', label: 'IPARKINGS' },
  { value: '102', label: 'ISA IjServ' },
  { value: '32', label: 'IT Sistemas' },
  { value: '3', label: 'Macrosoft' },
  { value: '38', label: 'Magma ERP' },
  { value: '86', label: 'MONTEVIDEO COMM' },
  { value: '67', label: 'MONTEVIDEO SOFTWARE' },
  { value: '72', label: 'NODUM' },
  { value: '7', label: 'POSCOMM' },
  { value: '2', label: 'Premium' },
  { value: '85', label: 'PRESENTIA - Progestion' },
  { value: '44', label: 'Prosys' },
  { value: '26', label: 'PSIG' },
  { value: '95', label: 'QFACTURA' },
  { value: '8', label: 'Real2b' },
  { value: '78', label: 'SER-TEC' },
  { value: '80', label: 'SERVIMATICA - Totem' },
  { value: '93', label: 'SIGMA SHOP' },
  { value: '5', label: 'Sisnet' },
  { value: '103', label: 'SOFT RESTAURANT' },
  { value: '50', label: 'Software 332' },
  { value: '104', label: 'Surbit DelySoft' },
  { value: '34', label: 'Urusys' },
  { value: '105', label: 'WorkSoft' },
  { value: '40', label: 'Zeta Libra' },
  { value: INTEGRATION_OTHERS, label: 'Otros' },
];

// TODO: provisional solution for coexistence of initial integrators and integrators modification requested
export const initialIntegratorsNotCurrentlyIncluded: { value: string; label: string }[] = [
  { value: '1', label: 'Visual SStoe' },
  { value: '10', label: 'Prosis Ltda' },
  { value: '11', label: 'Sistemas FerryLineas' },
  { value: '12', label: 'Synthesis' },
  { value: '13', label: 'Daniel Dupre' },
  { value: '14', label: 'Mauricio Pera' },
  { value: '15', label: 'Senda Cinema' },
  { value: '17', label: 'Luis Cruz' },
  { value: '18', label: 'Libros Libros' },
  { value: '21', label: 'Calculo' },
  { value: '22', label: 'Cofas' },
  { value: '23', label: 'SuperStore' },
  { value: '24', label: 'TOTO Calzados' },
  { value: '25', label: 'GRUPOT' },
  { value: '27', label: 'Jorge W. Ganón' },
  { value: '28', label: 'Floreal Perez' },
  { value: '29', label: 'ISA' },
  { value: '31', label: 'Enrique Grant' },
  { value: '33', label: 'Numina' },
  { value: '35', label: 'LOGIKOM' },
  { value: '36', label: 'DelySoft' },
  { value: '37', label: 'GestionFacil' },
  { value: '46', label: 'Giordano' },
  { value: '47', label: 'IMS Software' },
  { value: '51', label: 'Alberto Ganduglia' },
  { value: '52', label: 'NAD Caja' },
  { value: '53', label: 'DIEBOLD H&M' },
  { value: '54', label: 'CHAIA' },
  { value: '55', label: 'UCOT' },
  { value: '57', label: 'ENTERTEC' },
  { value: '59', label: 'ARNALDO CASTRO' },
  { value: '60', label: 'TBLSOFTWARE' },
  { value: '61', label: 'QUARXS' },
  { value: '62', label: 'Bit Cierre Lote Centralizado' },
  { value: '63', label: 'CLAUDIO ENRIQUE LUNA MARIN' },
  { value: '65', label: 'INVENZIS' },
  { value: '69', label: 'LAVOMAT' },
  { value: '70', label: 'PARALELO' },
  { value: '71', label: 'PUNTOEXE' },
  { value: '74', label: 'ASISTENCIAL MEDICA' },
  { value: '75', label: 'ClienteT4 API' },
  { value: '76', label: 'SAO' },
  { value: '77', label: 'ICG StandAlone NAD' },
  { value: '79', label: 'SANTA CLARA' },
  { value: '81', label: 'NAPSE' },
  { value: '82', label: 'POWER STREET' },
  { value: '87', label: 'DVELOP' },
  { value: '88', label: 'DISTRIBUIDORA SAN ANTONIO' },
  { value: '89', label: 'SILICOMP' },
  { value: '90', label: 'ICG IT' },
  { value: '91', label: 'GPSoftware' },
  { value: '92', label: 'RESTOSOFT' },
  { value: '94', label: 'ZONA TECNO' },
  { value: '96', label: 'SGCPYME' },
  { value: '97', label: 'AYP SOFT S.R.L' },
  { value: '98', label: 'PVP' },
  { value: '99', label: 'ITSISTEMAS' },
  { value: '100', label: 'SERVIMATICA' },
];

export const countriesPhoneCodes = [
  { label: 'AR', value: PhoneCountryCodesEnum.AR },
  { label: 'UY', value: PhoneCountryCodesEnum.UY },
  { label: 'BR', value: PhoneCountryCodesEnum.BR },
  { label: 'PY', value: PhoneCountryCodesEnum.PY },
];

export const smallBusinessDescription = 'Pequeña empresa';

export const tafaceBusinessType: InfoBlockField[] = [
  { name: 'Generico Plaza', value: TafaceBusinessTypeEnum.GENERIC_PLAZA },
  { name: 'Tienda Plaza', value: TafaceBusinessTypeEnum.STORE_PLAZA },
  { name: 'Literal E', value: TafaceBusinessTypeEnum.LITERAL_E },
  { name: 'Restaurante', value: TafaceBusinessTypeEnum.RESTAURANT },
];

export const tafaceCompanyType: InfoBlockField[] = [
  { name: 'Unipersonal', value: TafaceCompanyTypeEnum.UNI },
  { name: 'Sociedad Anónima', value: TafaceCompanyTypeEnum.SA },
  { name: 'Sociedad de Responsabilidad Limitada', value: TafaceCompanyTypeEnum.SRL },
  { name: 'Sociedad por Acciones Simplificada', value: TafaceCompanyTypeEnum.SAS },
  { name: 'Otro', value: TafaceCompanyTypeEnum.OTR },
];

export const tafaceDigitalCertificate: InfoBlockField[] = [
  { name: '1 año', value: TafaceCertificaDurationEnum['1 año'] },
  { name: '2 años', value: TafaceCertificaDurationEnum['2 años'] },
];
